import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "it", setLang: () => {} });
export const useLang = () => useContext(LangContext);
